<template>
	<div style="box-shadow: none; background-color: #fff; border-radius: 8px; border: 1px solid #ddd; min-height: 480px;">
		<v-container fluid @mouseenter="hover = true" @mouseleave="hover = false"> 
			<v-row>
				<div class="py-2 px-4 d-flex align-center justify-space-between" style="width: 100%; height: 56px;">
					<div>
						<h3>{{$t(config.title)}}
						<!--<v-tooltip bottom v-if="hover">
							<template v-slot:activator="{ on, attrs }">
								<v-icon color="grey lighten-1" style="cursor:pointer;" class="pl-1 pointer" dense v-bind="attrs" v-on="on">mdi-information</v-icon>
							</template>
							<span>{{$t(config.description)}}</span>
						</v-tooltip>-->
						</h3>
					</div>
					<!--<div v-if="!editMode && moduleLink" align="right" style="padding: 6px; margin-right:10px;">
							<a :href="moduleLink.href">{{ $t(moduleLink.title) }}</a>
					</div>-->
					<!--<div v-if="editMode" align="right" style="padding: 6px">
						<v-btn :disabled="!enableLeft" icon color="primary" @click="$emit('edit-action', -1)" ><v-icon>arrow_back</v-icon></v-btn>
						<v-btn :disabled="!enableRight" icon color="primary" @click="$emit('edit-action', 1)"><v-icon>arrow_forward</v-icon></v-btn>
						<v-btn icon color="primary" @click="$emit('edit-action', 0)"><v-icon>delete_outline</v-icon></v-btn>
					</div>-->
				</div>
			</v-row>
			<v-row>
				<TableWidget ref="tableWidget" v-if="config.type === 0" :config="config" :context="context" />
				<BarchartWidget ref="barchartWidget" v-if="config.type === 1" :config="config" :context="context" />
			</v-row>
		</v-container>
	</div>
</template>
 
 <script> 
 import BaseModule from './BaseModule'
 import TableWidget from './widgets/TableWidget'
 import BarchartWidget from './widgets/charts/BarchartWidget'

 export default {
  name: 'WidgetWrapper',
  props: ['config','context','editMode','enableLeft','enableRight'],
  mixins: [BaseModule],
  components: { 
    TableWidget, BarchartWidget
  },   
  data() {
    return {
      hover: false,
      moduleLink: {},
    }
  },
  mounted() {
    this.widgetConfig = JSON.parse(this.config.fields);
    this.moduleLink = this.widgetConfig.moduleLink?this.widgetConfig.moduleLink:{};
  },
	watch: {
    context: function() {         
		}
  },
  methods: {
		update() {
			for (const [key] of Object.entries(this.$refs)) {
				if (this.$refs[key].update) {
					this.$refs[key].update();
				}
			}
		}
  }
 };
 </script>